import React, { memo, useRef } from "react";
import CellInput from "./cellInput";
import styled from "styled-components";

const WordSelectedType = memo(
  ({
    element,
    selectedType,
    currentIndex,
    handleEditingCell = () => null,
    editingCell = null,
    handleUpdateCell = () => null,
    totalCells,
    readOnly = false,
    viewType,
    gridContainerWidth,
  }) => {
    const selectedTypeRef = useRef();
    const selectedTypeComponentWidth = selectedTypeRef.current?.offsetWidth;

    const handleClick = () => {
      if (readOnly) {
        return;
      }
      handleEditingCell(currentIndex);
    };

    const handleChange = (e) => {
      if (readOnly) {
        return;
      }
      handleUpdateCell(currentIndex, { value: e.target.value });
    };

    const handleBlur = () => {
      if (readOnly) {
        return;
      }
      handleEditingCell(null);
    };

    const handleKeyDown = (e) => {
      if (readOnly) {
        return;
      }
      if (e.key === "Enter" || e.key === "ArrowRight") {
        const nextIndex = (currentIndex + 1) % totalCells;
        handleEditingCell(nextIndex);
      } else if (e.key === "ArrowLeft") {
        const prevIndex =
          currentIndex === 0 ? totalCells - 1 : currentIndex - 1;
        handleEditingCell(prevIndex);
      } else if (e.key === "ArrowUp") {
        const checkRowCount = Math.floor(gridContainerWidth / selectedTypeComponentWidth);
        const rowIndex = Math.floor(currentIndex / checkRowCount);
        const columnIndex = currentIndex % checkRowCount;
        
        const prevRowIndex = rowIndex > 0 ? rowIndex - 1 : Math.floor((totalCells - 1) / checkRowCount);
        const nextIndex = Math.min(prevRowIndex * checkRowCount + columnIndex, totalCells - 1);
        
        handleEditingCell(nextIndex);
      } else if (e.key === "ArrowDown") {
        const checkRowCount = Math.floor(gridContainerWidth / selectedTypeComponentWidth);
        const rowIndex = Math.floor(currentIndex / checkRowCount);
        const columnIndex = currentIndex % checkRowCount;
        
        const nextRowIndex = (rowIndex + 1) % Math.ceil(totalCells / checkRowCount);
        const nextIndex = Math.min(nextRowIndex * checkRowCount + columnIndex, totalCells - 1);
        
        handleEditingCell(nextIndex);
      }
    };

    return (
      <Cell
        ref={selectedTypeRef}
        selectedType={selectedType}
        backgroundColor={element.backgroundColor}
        onClick={handleClick}
        className="word-cell"
        readOnly={readOnly}
        selected={element?.selected ? element?.selected : false}
        viewType={viewType}
      >
        {editingCell === currentIndex ? (
          <CellInput
            value={element.value || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            type={selectedType}
            currentIndex={currentIndex}
          />
        ) : (
          element.value || <span style={{ color: "#ccc" }}>Enter text</span>
        )}
      </Cell>
    );
  }
);

export default WordSelectedType;

const Cell = styled.div`
  min-width: ${(props) =>
    props?.viewType === "viewResultWheel" ? "150px" : ""};
  width: 100%;
  height: ${(props) =>
    props.selectedType === "Image" || props.selectedType === "VocabImage"
      ? "auto"
      : "150px"};
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  position: relative;
  cursor: ${(props) => (props.readOnly ? "default" : "pointer")};
  background-color: ${(props) => props?.backgroundColor ? props?.backgroundColor : "#333"};
  flex-direction: ${(props) =>
    props.selectedType === "Image" ? "column" : "row"};
  gap: ${(props) => (props.selectedType === "Image" ? "10px" : "0")};
  color: #fff;
  padding: ${(props) => (props.selectedType === "Image" ? "10px" : "0")};
  border: 3px dashed #080808;

  @media (max-width: 425px) {
    min-width: 150px;
  }
`;
